/**
 * offer-detail-al-v1 Component.
 *
 */
import { Component, EventEmitter, Input, OnInit, Output, ElementRef } from '@angular/core';
import { OfferDetailService , CommonService, ABTestService , UserInfoService , CartService , UtilService , ProductCouponService, ProductUtilService, CartV2Service, J4uV1Service } from 'abs-ngx-library/src/lib/core';
import { EnviormentConfig, IConfigObj, OfferDetailsData } from 'abs-ngx-library/src/lib/core';

// jQuery declaration
declare let $: any;

@Component({
    selector: 'offer-detail-al-v1',
    templateUrl: './offer-detail-al-v1.component.html'
})

export class OfferDetailALV1Component implements OnInit {

    @Input() offer;
    @Input() product;
    @Input() TriggerElement;
    @Output() backtoTriggeredComponent = new EventEmitter<any>();
    @Input() configObj: IConfigObj;
    @Input()
    public isBXGYEligibleOffer: boolean = false;

    public showAccordion: boolean = false;
    public detail:string;
    public description: string;
    public disclaimer: string;
    public offerDisclaimerExFrgPath:string;
    public offerText:string = '';
    public isDisclaimerLoaded: boolean = false;
    public bogoText = 'Buy 1 Get 1 Free';
    public bogoTextDetail = 'Add 2 Total for Offer';
    public showSpinner:boolean = false;
    public offerDataForOfferDetailsPage: OfferDetailsData = {};
    public couponType: any;
    public sm = '575px';
    public md = '768px';
    private imagePath: string = window['AB']['dMTProductCard'];
    public clippedLabel: string;
    public clipCouponLabel: string;
    public showLoadingCoupon: boolean = false;

    // DFTA - wcax env config
    private config = EnviormentConfig;
    public currentEnv: string = '';

    constructor(
                  private _offerDetailService: OfferDetailService,
                  private cartService: CartService ,
                  private _productCouponService: ProductCouponService,
                  private _userInfoService: UserInfoService,
                  private _utilService: UtilService,
                  private _productUtilService: ProductUtilService,
                  private _commonService: CommonService,
                  private cartV2Service: CartV2Service,
                  private _j4uV1Service: J4uV1Service,
                  private _elementRef: ElementRef,
               ) {
        this.currentEnv = this._commonService.getCurrentEnviorment();
        this.couponType = this.config[this.currentEnv].nimbusConfig.couponTypes;
        this.clipCouponLabel = this.config[this.currentEnv].nimbusConfig.couponActionTypes['CLC'];
        this.clippedLabel = this.config[this.currentEnv].nimbusConfig.couponActionTypes['CLD'];
      }


    public ngOnInit() {

        try {
            // For SNS One Time Add flow, we will refer data-attributes for offer, product and config objects.
            const dataConfigObj = this._elementRef.nativeElement.getAttribute('data-configObj');
            if (!this._commonService.isEmpty(dataConfigObj)) {
                this.configObj = JSON.parse(dataConfigObj);
                if (this.configObj?.programType === '1P_SNS' || this.configObj.appName === '1P_OA') {
                    const offer = this._elementRef.nativeElement.getAttribute('data-offer');
                    this.offer = JSON.parse(offer);
                }
            }
        } catch (error) {
            console.error('Error parsing data attributes:', error);
        }

        this._commonService.shopCouponRefreshSource.subscribe((couponRefresh) => {
            if (couponRefresh && typeof couponRefresh === 'object' && 'id' in couponRefresh && 'status' in couponRefresh) {

                // Check if this refresh event is for our current offer
                if (this.offer && this.offer.offerId === couponRefresh.id) {

                    // Update the offer status
                    this.offer.status = couponRefresh.status;
                    this.offer.deleted = couponRefresh.deleted;

                    // Also update offerDataForOfferDetailsPage for B4U pages
                    if (this.offerDataForOfferDetailsPage && this.offerDataForOfferDetailsPage.offerId === couponRefresh.id) {
                        this.offerDataForOfferDetailsPage.status = couponRefresh.status;
                        this.offerDataForOfferDetailsPage.deleted = couponRefresh.deleted;
                    }

                    // Force change detection to update UI immediately
                    // this.cdr.detectChanges();
                }
            }
        });

        if (this.offer){
            this.showSpinner = true;

            this.offer.offerId = this.getOfferIdentifier(this.offer);
            this.offer.offerPgm = this.getOfferProgram(this.offer);

            // For initial DNF no coupon-carousel so did not clean this yet
            if (this.TriggerElement === 'coupon-carousel' || (this.configObj && this.configObj.appName && this.configObj.appName === 'weeklyAd')){
                this.offerText = window['SWY'].CONFIGSERVICE.nimbusConfig.offerTypes[this.offer.usageType];
            } else {
                this.offerText = `Add ${this.offer.minPurchaseQty} Total for Offer`;
            }

            this.offerDisclaimerExFrgPath = this.config.offerDisclaimerPath;

            if (this.offer.itemType && this.offer.itemType === 'product') {
                this._offerDetailService.getCMSOfferData(this.offer.custom3, this.configObj).subscribe(data => {
                    this.showSpinner = false;
                }, err => {});
            } else {
                this._offerDetailService.getOfferDetailData(this.offer.offerId, this.offer.offerPgm, this.configObj)
                .subscribe(response => {
                    if (!this._commonService.isEmpty(response)) {
                        this.detail = (response.offerDetail && response.offerDetail.details) ? response.offerDetail.details : '';
                        this.offer.ecomDescription =
                            (response.offerDetail && response.offerDetail.ecomDescription) ? response.offerDetail.ecomDescription : '';
                        this.offer.isClippable = !!response.offerDetail?.isClippable;
                        this.showSpinner = false;

                        if (response.status) {
                            this.offer.status = response.status;
                        }
                        this.offer.deleted = (response.deleted !== undefined) ? !!response.deleted : !!this.offer.deleted;

                        if (this.configObj && this.configObj.appName && this.configObj.appName === 'weeklyAd') {
                            this.offerText = window['SWY'].CONFIGSERVICE.nimbusConfig.offerTypes[response.usageType];
                            this.offer['endDate'] = response.offerEndDate;
                            this.offer.status = (response.status) ? response.status : 'U';
                            this.offer.deleted = response.deleted || false;
                        }
                        if (this.configObj && this.configObj.appName && (this.configObj.appName === 'b4u' || this.configObj.appName === '1P_OA')) {
                            this.transformDataForOfferDetailsPage(response);
                            if (!this.isDisclaimerLoaded) {
                                this._offerDetailService.getOfferDisclaimerTemplate(this.offerDisclaimerExFrgPath, this.configObj).subscribe( response => {
                                    if (response) {
                                        this.offerDataForOfferDetailsPage.disclaimer = response.replace(/<(?:.|\n)*?>/gm, ' ');
                                        this.isDisclaimerLoaded = true;
                                    }
                                });
                            }
                        }
                    }
                }, err => {});
                if (!this.offer.status) { this.offer.status = 'U'; }
                if (this.offer.deleted === undefined) { this.offer.deleted = false; }
            }

        }
        if (this.product) {
            this._commonService.currentCartObj.subscribe(objCart => {
                if (objCart){
                    const currentCart =
                    this.cartV2Service.fetchCartDetailsFromResponse(objCart, this.cartV2Service.getCartName(this.configObj.programType));
                    if (this.offer){
                        const arrOffer = [];
                        arrOffer.push(this.offer);
                        this.cartService.processOfferComplete(currentCart, arrOffer, this.product);
                    } else {
                        this.cartService.processBOGOComplete(currentCart, this.product);
                    }
                }
            });
        }
        // set bogo text
        this.setBogoText();
    }

    public transformDataForOfferDetailsPage(data) {
        const savings = (data.offerDetail.offerPrice) ? data.offerDetail.offerPrice : '';
        this.offerDataForOfferDetailsPage.savings =
            ((data.priceTitle && data.priceTitle !== '' && savings.indexOf(data.priceTitle) === -1 ) ?
                `${data.priceTitle} ${savings}` : savings);
        this.offerDataForOfferDetailsPage.savings = (this.offerDataForOfferDetailsPage.savings !== '')
            ? this.offerDataForOfferDetailsPage.savings : data.offerDetail.forUDescription;
        this.offerDataForOfferDetailsPage.regularPrice = (data.regularPrice) ? data.regularPrice : '';
        this.offerDataForOfferDetailsPage.description = data.offerDetail.description;
        this.offerDataForOfferDetailsPage.title = data.offerDetail.name;
        this.offerDataForOfferDetailsPage.offerSubPgm = data.offerSubPgm;
        this.offerDataForOfferDetailsPage.status = data.deleted ? 'U' : (data.status ? data.status : 'U');
        this.offerDataForOfferDetailsPage.deleted = data.deleted;
        this.offerDataForOfferDetailsPage.offerId = data.offerId;
        this.offerDataForOfferDetailsPage.offerPgm = data.offerPgm;
        this.offerDataForOfferDetailsPage.endDate = data.offerEndDate;
        this.offerDataForOfferDetailsPage.imageId = data.imageId;
        this.offerDataForOfferDetailsPage.offerProtoType = data.offerProtoType;
        this.offerDataForOfferDetailsPage.continuity = data.continuity;
        this.offerDataForOfferDetailsPage.offerType = data.offerPgm === 'TR' && data.usageType === 'U' && data.quantity !== undefined ?  `${data.quantity} use${parseInt(data.quantity) > 1 ? 's' : ''} available` : window['SWY'].CONFIGSERVICE.nimbusConfig.offerTypes[data.usageType];
        this.offerDataForOfferDetailsPage.detail = (data.offerDetail.details) ? data.offerDetail.details : '';
    }

    public toggleAccordion(){
        if (!this.isDisclaimerLoaded){
            this._offerDetailService.getOfferDisclaimerTemplate(this.offerDisclaimerExFrgPath, this.configObj).subscribe(response => {
                if (response) {
                    $('.offer-detail-v2 .offer-disclaimer').append(response);
                    this.showAccordion = true;
                    this.isDisclaimerLoaded = true;
                }
            });
        } else{
            this.showAccordion = !this.showAccordion;
        }
    }

    /**
     * Method to set BOGO Title and BOGO description
     */
    private setBogoText() {
        this.bogoText = this.product?.promoDescription ? `${this.product.promoDescription}` : '';
        this.bogoTextDetail = this.product?.promoText ? this.product.promoText : '';
    }
    public clipCoupon() {
        this.showLoadingCoupon = true;
        if (this._isRegistered()){
            const storeId = this._userInfoService.getShopStoreId();
            const analyticsData = {
                nativeElement: this._elementRef.nativeElement
            };
            this._j4uV1Service.clipCoupon(this.offer, storeId, this.configObj, false, analyticsData)
            .subscribe(response => {

                if (response && response['items'] && response['items'][0] && response['items'][0]['status'] === 1) {
                    this.showLoadingCoupon = false;
                    this.offer.status = 'C';
                    this.offerDataForOfferDetailsPage.status = 'C';
                    // J4uV1Service.clipCoupon already broadcasts on shopCouponRefreshSource
                }
            });
        } else {
            this.showLoadingCoupon = false;
            if (this.configObj && this.configObj.appName && this.configObj.appName === 'weeklyAd') {
                const bannerDomainUrl = this._productUtilService.getBannerDomainUrl(this.configObj);
                window.location.assign(bannerDomainUrl + window['AB'].signInLinkPath);
            } else {
                window['rightDrawerComp'].closeDrawer();
                window['AB']['COMMON'].showSignInModal_OTP(window.location.href);
            }
        }
    }

    public backtoComponent(){
        const offer = this.offer ? this.offer : null;
        this.backtoTriggeredComponent.emit(offer);
    }

    /**
     * Method to return true or false based on token status and authorize
     */
  private _isRegistered(): boolean {
    return (this._utilService.isTokenActive() && this._userInfoService.isAuthorized());
  }

  public getImageUrl(viewport: string): string {
    const modifiedImagePath = this.imagePath || '//images.albertsons-media.com/is/image/ABS/${product.id}?$ecom-product-card-${viewport}-jpg$&defaultImage=Not_Available';
    return modifiedImagePath ?
        modifiedImagePath.replace('${product.id}', this.offerDataForOfferDetailsPage.imageId).replace('${viewport}', viewport) : '';
  }

    private getOfferIdentifier(offer: any): any {
        if (!offer) {
                return '';
        }

        return offer.offerId || offer.omsOfferId || offer.couponID || offer.couponId || offer.id || '';
    }

    private getOfferProgram(offer: any): any {
        if (!offer) {
                return '';
        }

        return offer.offerPgm || offer.offerProgram || offer.offerType || offer.offerProgramType || '';
    }

}
